/** 패널 너비 500 · 최대 높이 400 · 빈 줄 높이 50(Figma). 토큰에 없는 값이라 인라인 style */
export const GLOBAL_SEARCH_PANEL_PX = { width: 500, maxHeight: 400 } as const;
export const GLOBAL_SEARCH_BLANK_HEIGHT_PX = 50;
